export const transactionAmountClass = (transactionType) => {
  const normalizedType = String(transactionType || "").toLowerCase();

  if (normalizedType === "debit") {
    return "cw-transaction-amount cw-transaction-amount-debit";
  }

  if (normalizedType === "credit") {
    return "cw-transaction-amount cw-transaction-amount-credit";
  }

  return "cw-transaction-amount";
};
